export const FETCH_VAT_RATES = {
  START: 'FETCH_VAT_RATES_START',
  SUCCESS: 'FETCH_VAT_RATES_SUCCESS',
  ERROR: 'FETCH_VAT_RATES_ERROR',
};

export const SET_VAT_RATES = {
  START: 'SET_VAT_RATES_START',
  SUCCESS: 'SET_VAT_RATES_SUCCESS',
  ERROR: 'SET_VAT_RATES_ERROR',
};
